import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import MyProfile from "./components/Login/Myprofile";
export const isAuthenticated = () => {
  const user_id = localStorage.getItem("userid");
  return !!user_id;
};

const AccountRoute = () => {
  const [authenticated, setAuthenticated] = useState(isAuthenticated());

  useEffect(() => {
    const checkAuth = () => {
      setAuthenticated(isAuthenticated());
    };
    window.addEventListener("storage", checkAuth); // Listen for localStorage changes
    return () => {
      window.removeEventListener("storage", checkAuth); // Cleanup listener
    };
  }, []);

  return authenticated ? <MyProfile /> : <Navigate to="/login" />;
};

export default AccountRoute;
